// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u1ZR3SrRMqzsnWg8RFe9 {
  background-color: var(--purple);
}

.n2sVTHP0jGBABFSMoAQF {
  position: relative;
  z-index: 2;
  background-color: var(--header-background-v2);
}

.SkJo3sDOymmW0Ok1WptK {
  background: var(--header-background-v2);
  height: 5rem;
  max-width: var(--content-column);
  margin: 0 auto;
  padding: 0.875rem var(--content-padding);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.uYcfC5eZgnME8_H5hUhg,
.VNrH6TxhHEke7bOjfRe2,
.hOdv5tGTOAe5j4CsVICZ,
.VBjAmJmlV_VLsFdTTC7R {
  display: flex;
  align-items: center;
}

.VBjAmJmlV_VLsFdTTC7R {
  grid-gap: 0.9375rem;
  gap: 0.9375rem;
}

.hOdv5tGTOAe5j4CsVICZ {
  margin-right: 2rem;
}

.C1XzcIN8U4Yw6AbkdxM3 {
  position: relative;
  display: flex;
  flex-direction: column;
}

.C3WwAmbPnWKXs1QhNCV8 {
  margin-right: 2rem;
  margin-left: 2rem;
}

.ZW2jI7CTwOvDWBjQIGYt {
  width: 16.375rem;
  height: auto;
}

.jknC6lxNVKtmBQF41p2j {
  border: none;
  outline: none;
  background-color: transparent;
  margin-right: 1.5rem;
  padding: 0;
}

.a7pBXdr1siuODfNS_kig {
  opacity: 0.4;
}

.TIvJKO4gRGFeIKc2kVN5 {
  opacity: 1;
  transition: opacity 0.3s ease;
}

.x8xZO0mC9DBLQKP0WdTy {
  opacity: 0;
  height: 0;
  width: 0;
  transition: opacity 0.3s ease;
}

.Pz0Gb63N_Xt7aCS1yVpA {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 1.125rem 0 0.875rem;
  padding: 0.5rem 1rem;
  border-radius: 2.5rem;
}

.Q_aLE7_co7TMY92grz8c {
  background-color: var(--white);
}

.tpfWoeOZwPLUwvTYGgd9 {
  margin-right: 0.5rem;
  color: var(--header-text-color-v2);
}

.Vtf9c_KHcxSLvizqj5Ud {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  height: 100%;
  background-color: #fff;
}

.IRWQNraoEUEbzWdepzYg {
  margin-left: 2rem;
}

._1ePMshimfGm_rr2eG7p {
  color: var(--header-text-color-v2);
}

.JKGhvFmXbcA0yUQSlF1l {
  color: var(--header-text-color-v2);
}

.K98LKD3txOuAzh1ZwQ5P {
  color: var(--header-text-color-v2);
}

.ze_e8jSZ1wyxOE5gr5qk {
  color: var(--header-category-highlight-color-v2);
  background-color: var(--white);
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .SkJo3sDOymmW0Ok1WptK {
    padding: 0.75rem var(--content-padding-desktop-small);
  }

  .SQZJ9Wowx1v449mEFm9i {
    padding: 0 var(--content-padding-tablet) 0.75rem;
  }
}

@media only screen and (min-width: 1023px) and (max-width: 1300px) {
  .JKGhvFmXbcA0yUQSlF1l {
    font-size: 0.875rem;
  }

  .Pz0Gb63N_Xt7aCS1yVpA {
    margin-left: 1.5rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .K98LKD3txOuAzh1ZwQ5P {
    color: var(--header-text-color-v2);
    font-size: 0.625rem;
    line-height: 0.875rem;
  }

  .SkJo3sDOymmW0Ok1WptK {
    padding: 0 var(--content-padding-tablet) 0.75rem;
  }

  .ZW2jI7CTwOvDWBjQIGYt {
    width: 7rem;
  }

  .Vtf9c_KHcxSLvizqj5Ud {
    background-color: var(--grey-100);
  }

  .Pz0Gb63N_Xt7aCS1yVpA {
    margin-left: 3rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .K98LKD3txOuAzh1ZwQ5P {
    color: var(--header-text-color-v2);
    font-size: 0.625rem;
    line-height: 0.875rem;
  }

  .Vtf9c_KHcxSLvizqj5Ud {
    background-color: var(--grey-100);
  }

  .jknC6lxNVKtmBQF41p2j {
    margin-right: 0.875rem;
  }

  .SkJo3sDOymmW0Ok1WptK {
    padding: 0 var(--content-padding-mobile) 0.75rem;
  }

  .ZW2jI7CTwOvDWBjQIGYt {
    width: 7.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderV2/HeaderV2.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,wCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAS;EAAT,cAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,oBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAAqB;EACrB,oBAAiB;EACjB,qBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;;;EACE;IACE,qDAAkD;EACpD;;EAEA;IACE,gDAA6C;EAC/C;AACF;;AAEA;EACE;IACE,mBAAe;EACjB;;EAEA;IACE,mBAAiB;EACnB;AACF;;AAEA;;;EACE;IACE,kCAAkC;IAClC,mBAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,gDAA6C;EAC/C;;EAEA;IACE,WAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EACE;IACE,kCAAkC;IAClC,mBAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAkB;EACpB;;EAEA;IACE,gDAA6C;EAC/C;;EAEA;IACE,cAAY;EACd;AACF","sourcesContent":[".rootContainer {\n  background-color: var(--purple);\n}\n\n.header {\n  position: relative;\n  z-index: 2;\n  background-color: var(--header-background-v2);\n}\n\n.headerContent {\n  background: var(--header-background-v2);\n  height: 80px;\n  max-width: var(--content-column);\n  margin: 0 auto;\n  padding: 14px var(--content-padding);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.leftSide,\n.rightSide,\n.rightNavLinks,\n.rightNavIcons {\n  display: flex;\n  align-items: center;\n}\n\n.rightNavIcons {\n  gap: 15px;\n}\n\n.rightNavLinks {\n  margin-right: 32px;\n}\n\n.basketLink {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.businessPageLink {\n  margin-right: 32px;\n  margin-left: 32px;\n}\n\n.logo {\n  width: 262px;\n  height: auto;\n}\n\n.menuDropdownBtn {\n  border: none;\n  outline: none;\n  background-color: transparent;\n  margin-right: 24px;\n  padding: 0;\n}\n\n.disabled {\n  opacity: 0.4;\n}\n\n.menuDropdownIconVisible {\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.menuDropdownIconInvisible {\n  opacity: 0;\n  height: 0;\n  width: 0;\n  transition: opacity 0.3s ease;\n}\n\n.menuDropdownLinkBtn {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 18px 0 14px;\n  padding: 8px 16px;\n  border-radius: 40px;\n}\n\n.menuDropdownLinkBtnActive {\n  background-color: var(--white);\n}\n\n.giftCardDropdownBtnTitle {\n  margin-right: 8px;\n  color: var(--header-text-color-v2);\n}\n\n.headerMenuWrapper {\n  display: flex;\n  flex-direction: column;\n  overflow-x: auto;\n  height: 100%;\n  background-color: #fff;\n}\n\n.choiceGiftcardLink {\n  margin-left: 32px;\n}\n\n.textClassName {\n  color: var(--header-text-color-v2);\n}\n\n.text {\n  color: var(--header-text-color-v2);\n}\n\n.rightNavLinksText {\n  color: var(--header-text-color-v2);\n}\n\n.activeNavItem {\n  color: var(--header-category-highlight-color-v2);\n  background-color: var(--white);\n}\n\n@media (--desktop-small) {\n  .headerContent {\n    padding: 12px var(--content-padding-desktop-small);\n  }\n\n  .headerContentWithIconText {\n    padding: 0 var(--content-padding-tablet) 12px;\n  }\n}\n\n@media only screen and (min-width: 1023px) and (max-width: 1300px) {\n  .text {\n    font-size: 14px;\n  }\n\n  .menuDropdownLinkBtn {\n    margin-left: 24px;\n  }\n}\n\n@media (--tablet) {\n  .rightNavLinksText {\n    color: var(--header-text-color-v2);\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .headerContent {\n    padding: 0 var(--content-padding-tablet) 12px;\n  }\n\n  .logo {\n    width: 112px;\n  }\n\n  .headerMenuWrapper {\n    background-color: var(--grey-100);\n  }\n\n  .menuDropdownLinkBtn {\n    margin-left: 48px;\n  }\n}\n\n@media (--mobile) {\n  .rightNavLinksText {\n    color: var(--header-text-color-v2);\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .headerMenuWrapper {\n    background-color: var(--grey-100);\n  }\n\n  .menuDropdownBtn {\n    margin-right: 14px;\n  }\n\n  .headerContent {\n    padding: 0 var(--content-padding-mobile) 12px;\n  }\n\n  .logo {\n    width: 116px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootContainer": `u1ZR3SrRMqzsnWg8RFe9`,
	"header": `n2sVTHP0jGBABFSMoAQF`,
	"headerContent": `SkJo3sDOymmW0Ok1WptK`,
	"leftSide": `uYcfC5eZgnME8_H5hUhg`,
	"rightSide": `VNrH6TxhHEke7bOjfRe2`,
	"rightNavLinks": `hOdv5tGTOAe5j4CsVICZ`,
	"rightNavIcons": `VBjAmJmlV_VLsFdTTC7R`,
	"basketLink": `C1XzcIN8U4Yw6AbkdxM3`,
	"businessPageLink": `C3WwAmbPnWKXs1QhNCV8`,
	"logo": `ZW2jI7CTwOvDWBjQIGYt`,
	"menuDropdownBtn": `jknC6lxNVKtmBQF41p2j`,
	"disabled": `a7pBXdr1siuODfNS_kig`,
	"menuDropdownIconVisible": `TIvJKO4gRGFeIKc2kVN5`,
	"menuDropdownIconInvisible": `x8xZO0mC9DBLQKP0WdTy`,
	"menuDropdownLinkBtn": `Pz0Gb63N_Xt7aCS1yVpA`,
	"menuDropdownLinkBtnActive": `Q_aLE7_co7TMY92grz8c`,
	"giftCardDropdownBtnTitle": `tpfWoeOZwPLUwvTYGgd9`,
	"headerMenuWrapper": `Vtf9c_KHcxSLvizqj5Ud`,
	"choiceGiftcardLink": `IRWQNraoEUEbzWdepzYg`,
	"textClassName": `_1ePMshimfGm_rr2eG7p`,
	"text": `JKGhvFmXbcA0yUQSlF1l`,
	"rightNavLinksText": `K98LKD3txOuAzh1ZwQ5P`,
	"activeNavItem": `ze_e8jSZ1wyxOE5gr5qk`,
	"headerContentWithIconText": `SQZJ9Wowx1v449mEFm9i`
};
export default ___CSS_LOADER_EXPORT___;
